module.exports = __webpack_public_path__ + "static/img/natasha_pictgrid21_1020x847.645611b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/natasha_pictgrid21_1020x847.jpg
// module id = V6pO
// module chunks = 0